
import ls from '../LStorage';
export default {
	state: {
		list:[],
        routerPermissionList:ls.getItem('routerPermissionList') || [],
		leafParent:[],
		countdb:'',
		msg:{},
		stomp:{},
		num:'',
		scroll:null,
		type:{}

	},
	mutations: {
		setList(state,list){
			state.list = list;
		},
        setRouterList(state,routerPermissionList){
            state.routerPermissionList = routerPermissionList;
            ls.setItem('routerPermissionList', routerPermissionList);
        },
		setLeafParent(state,list){
			state.leafParent = list;
		},
		setCountdb(state,count){
			//console.log(state)
            //console.log(count)
			if(count==0){
			    state.countdb = '';
			}else{
				state.countdb = count;
			}
			// if(state.countdb!=0){
			//    state.countdb = count;
			// }
		},
		setMsg(state,msg){
			//console.log(msg)
			state.msg = msg;
		},
		setStomp(state,stomp){
			//console.log(stomp)
			state.stomp = stomp;
		},
		setWaraing(state,num){
			//console.log(state)
            if(num==0){
                state.num = '';
            }else{
                state.num = num;
            }
			//state.num = num;
		},
		setType(state,type){
			state.type = type;
		},
		setScroll(state,scroll){
			state.scroll = scroll;
		}
	},
};



// WEBPACK FOOTER //
// ./src/store/module/menu.js